import React from 'react';
import { IProps } from 'components/Modal/types';

class Modal extends React.Component<IProps, {}> {
  static defaultProps = {
    confirmButton: true,
    confirmButtonText: '確認',
    cancelButton: false,
    cancelButtonText: '取消',
    overlayDismiss: true,
    closeIcon: true
  };

  componentDidMount () {
    this.handleModalLockScroll(this.props.visible);
  }

  componentWillUnmount () {
    this.handleModalLockScroll(false);
  }

  // Modal 開啟時鎖定 body scroll
  handleModalLockScroll = (lockup: boolean) => {
    document.body.style.overflow = lockup ? 'hidden' : 'unset';
  }

  // 處理 Confirm 按鈕點擊後執行的事件
  handleConfirm = () => {
    this.props.onConfirm && this.props.onConfirm();
  }

  // 處理 Modal 取消
  handleCancel = () => {
    this.props.onCancel && this.props.onCancel();
  }

  handleOverlayDismiss = () => {
    if (this.props.overlayDismiss) this.handleCancel();
  }

  render () {
    const { containerStyles } = this.props;
    const {
      children,
      visible,
      icon,
      title,
      confirmButton,
      confirmButtonText,
      cancelButton,
      cancelButtonText,
      closeIcon,
      idName
    } = this.props;
    const modalClasses = ['modal'];
    if (visible) modalClasses.push('modal--active');

    return (
      <div className={modalClasses.join(' ')}>
        <div style={containerStyles ?? {}} className="modal__container" id={idName}>
          {(title || icon) && (
            <div className="modal__header">
              {icon && <i className={`modal__icon modal__icon--${icon}`} />}
              {title && <h4>{title}</h4>}
            </div>
          )}
          <div className="modal__content">
            {children}
          </div>
          {confirmButton && (
            <button type="button" className="modal__confirm-button" onClick={this.handleConfirm}>
              {confirmButtonText}
            </button>
          )}
          {cancelButton && (
            <span className="modal__cancel-button" onClick={this.handleCancel}>
              {cancelButtonText}
            </span>
          )}
          {closeIcon && (
            <button type="button" className="modal__close-icon" onClick={this.handleCancel} />
          )}
        </div>
        <div className="modal__background" onClick={this.handleOverlayDismiss} />
      </div>
    );
  }
}

export default Modal;
